const TOKEN_KEY = "id_token";
const BRANCH_ID = "branch_id";

export default {
  getBranchId() {
    return window.localStorage.getItem(BRANCH_ID);
  },

  getToken() {
    return window.localStorage.getItem(TOKEN_KEY);
  },

  saveToken(token) {
    window.localStorage.setItem(TOKEN_KEY, token);
  },

  setBranch(_branchId) {
    window.localStorage.setItem(BRANCH_ID, _branchId);
  },

  destroyBranch() {
    window.localStorage.removeItem(BRANCH_ID);
  },

  destroyToken() {
    window.localStorage.removeItem(TOKEN_KEY);
  }
};
